import React, { useState } from 'react';
import AntdProForm, { ProFormText } from '@ant-design/pro-form';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import './style.less';
import PropTypes from 'prop-types';
import { Card } from 'antd';

const HtmlInput = ({
  form,
  label,
  placeholder,
  extraBefore,
  name,
  required,
  requiredMessage,
  ...props
}) => {
  const [editorState, setEditorState] = useState(
    BraftEditor.createEditorState(form.getFieldValue(name))
  );
  const controls = [
    'undo',
    'redo',
    'separator',
    'font-size',
    'line-height',
    'letter-spacing',
    'separator',
    'text-color',
    'bold',
    'italic',
    'underline',
    'strike-through',
    'separator',
    'superscript',
    'subscript',
    'remove-styles',
    'emoji',
    'separator',
    'text-indent',
    'text-align',
    'separator',
    'headings',
    'list-ul',
    'list-ol',
    'blockquote',
    'code',
    'separator',
    'link',
    'separator',
    'hr',
    'separator',
    'clear',
  ];
  const handleChange = (editorState) => {
    setEditorState(editorState);
    form.setFieldsValue({ [name]: editorState.toHTML() });
  };
  return (
    <>
      <AntdProForm.Item label={label} required={required} {...props}>
        {extraBefore}
        <Card>
          <BraftEditor
            language="en"
            placeholder={placeholder}
            controls={controls}
            value={editorState}
            onChange={handleChange}
          />
        </Card>
      </AntdProForm.Item>
      <div className="hidden-html-input">
        <ProFormText
          name={name}
          readonly
          rules={
            required
              ? [
                  {
                    validator: async (_, value) => {
                      if (
                        value === undefined ||
                        value?.length < 1 ||
                        value === '<p></p>'
                      ) {
                        return Promise.reject(
                          new Error(requiredMessage || 'Please enter')
                        );
                      }
                    },
                  },
                ]
              : []
          }
        />
      </div>
    </>
  );
};

HtmlInput.defaultProps = {
  name: 'html',
  placeholder: 'Please enter',
  required: false,
  requiredMessage: 'Please enter',
};

HtmlInput.propTypes = {
  name: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  extraBefore: PropTypes.node,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  requiredMessage: PropTypes.string.isRequired,
};

export default HtmlInput;
